import axios from "@/plugins/axios";

let url = "/api/console/shop/inquires";

export default {
    getInquires(data){
        return axios.get(url, data).then(result => result.data);
    },
    getInquire(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    postInquire(data){
        return axios.post(url, data).then(result => result.data);
    },
    putInquire(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deleteInquire(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
